import { render } from "./payperiod.svg?vue&type=template&id=b8db7196"
const script = {}
script.render = render

export default script